import {
  RadioButton,
  ReactEasyForm,
  Select,
} from "@aeco-cloud/react-easy-form";
import { Typography, useTheme } from "@material-ui/core";
import ErrorOutlineOutlinedIcon from "@material-ui/icons/ErrorOutlineOutlined";
import Link from "@material-ui/core/Link";
import { useContext } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { TextContext } from "../../../pages/bepaal-statuut";
// import { selectButtonsProps } from "./../reactEasyFormSettings";
import settings from "../../../styles/settings";
import { Label, NavigationButtons, Question, Section } from "../../form-layout";
import StepBody from "../../form-layout/StepBody";
import Markdown from "../../Markdown";
import ReactMarkdown from "markdown-to-jsx";
import { SendContext } from "../BepaalStatuut";

export type SituationData = {
  situation: string;
  type: string;
  educationDeferredRenumeration?: "true" | "false";
};

const Situatie = () => {
  const text = useContext(TextContext);
  const send = useContext(SendContext);
  const form = useForm();
  const theme = useTheme();
  const situation = form.watch("situation");
  const fullTime = form.watch("fulltime");

  const onSubmit: SubmitHandler<any> = (data) => {
    console.log(data);
    send({ type: "NEXT", data: data });
  };

  const onBack = () => {
    send({ type: "BACK" });
  };

  return (
    <ReactEasyForm form={form}>
      <StepBody>
        <Section>
          <Question>
            <Label
              label={text.situation_situation_label}
              tooltip={text.situation_situation_tooltip}
            />
            <RadioButton
              minButtonWidth="300px"
              name="situation"
              {...settings.selectButtonsProps}
              options={[
                {
                  value: "civilServant",
                  label: text.situation_situation_civilServant,
                },
                { value: "employee", label: text.situation_situation_employee },
                { value: "student", label: text.situation_situation_student },
                { value: "benefits", label: text.situation_situation_benefits },
              ]}
              rules={{
                required: text.general_requiredQuestion,
              }}
            />
          </Question>
          <Question showIf={["employee", "civilServant"].includes(situation)}>
            <Label
              label={text.situation_fulltime_label}
              tooltip={text.situation_fulltime_tooltip}
            />
            <RadioButton
              name="fulltime"
              minButtonWidth="240px"
              {...settings.selectButtonsProps}
              options={[
                { value: "true", label: text.general_yes },
                { value: "false", label: text.general_no },
              ]}
              rules={{
                required: text.general_requiredQuestion,
              }}
            />
          </Question>
          <Question
            showIf={situation === "civilServant" && fullTime === "false"}
          >
            <Label label={text.situation_typeCivilServant_label} />
            <Select
              muiSelectProps={{ fullWidth: true, variant: "outlined" }}
              name="type"
              {...settings.selectButtonsProps}
              rules={{
                required: text.general_requiredQuestion,
              }}
              options={[
                {
                  value: "GROUP",
                  label: text.situation_typeCivilServant_group1,
                },
                {
                  value: "ordinary",
                  label: text.situation_typeCivilServant_ordinary,
                },
                {
                  value: "education",
                  label: text.situation_typeCivilServant_education,
                },
                {
                  value: "educationWithEmployeeActivity",
                  label:
                    text.situation_typeCivilServant_educationWithEmployeeActivity,
                },
                {
                  value: "GROUP",
                  label: text.situation_typeCivilServant_group2,
                },
                {
                  value: "careerBreak",
                  label: text.situation_typeCivilServant_careerBreak,
                },
                {
                  value: "flemishCareCredit",
                  label: text.situation_typeCivilServant_flemishCareCredit,
                },
                {
                  value: "thematicLeave",
                  label: text.situation_typeCivilServant_thematicLeave,
                },
                {
                  value: "specialLeaveArrangements",
                  label:
                    text.situation_typeCivilServant_specialLeaveArrangements,
                },
                {
                  value: "mutualiteit",
                  label: text.situation_typeCivilServant_mutualiteit,
                },
              ]}
            />
          </Question>
          <Question showIf={situation === "employee" && fullTime === "false"}>
            <Label label={text.situation_typeEmployee_label} />
            <Select
              muiSelectProps={{ fullWidth: true, variant: "outlined" }}
              name="type"
              {...settings.selectButtonsProps}
              rules={{
                required: text.general_requiredQuestion,
              }}
              options={[
                { value: "GROUP", label: text.situation_typeEmployee_group1 },
                {
                  value: "whiteCollarWorker",
                  label: text.situation_typeEmployee_whiteCollarWorker,
                },
                {
                  value: "blueCollarWorker",
                  label: text.situation_typeEmployee_blueCollarWorker,
                },
                {
                  value: "temporaryWorker",
                  label: text.situation_typeEmployee_temporaryWorker,
                },
                {
                  value: "teacher",
                  label: text.situation_typeEmployee_teacher,
                },
                {
                  value: "weekendTeam",
                  label: text.situation_typeEmployee_weekendTeam,
                },
                { value: "phd", label: text.situation_typeEmployee_phd },
                {
                  value: "flexijob",
                  label: text.situation_typeEmployee_flexijob,
                },
                {
                  value: "individualVocationalTraining",
                  label:
                    text.situation_typeEmployee_individualVocationalTraining,
                },
                { value: "abroad", label: text.situation_typeEmployee_abroad },
                { value: "GROUP", label: text.situation_typeEmployee_group2 },
                {
                  value: "timeCreditCare",
                  label: text.situation_typeEmployee_timeCreditCare,
                },
                {
                  value: "timeCreditTraining",
                  label: text.situation_typeEmployee_timeCreditTraining,
                },
                {
                  value: "careerBreak",
                  label: text.situation_typeEmployee_careerBreak,
                },
                {
                  value: "thematicLeave",
                  label: text.situation_typeEmployee_thematicLeave,
                },
                {
                  value: "specialLeaveArrangements",
                  label: text.situation_typeEmployee_specialLeaveArrangements,
                },
                {
                  value: "flemishCareCredit",
                  label: text.situation_typeEmployee_flemishCareCredit,
                },
                {
                  value: "terminationFee",
                  label: text.situation_typeEmployee_terminationFee,
                },
                {
                  value: "severancePayment",
                  label: text.situation_typeEmployee_severancePayment,
                },
                {
                  value: "mutualiteit",
                  label: text.situation_typeEmployee_mutualiteit,
                },
              ]}
            />
          </Question>
          <Question showIf={form.watch("situation") === "benefits"}>
            <Label label={text.situation_typeBenefits_label} />
            <Select
              rules={{
                required: text.general_requiredQuestion,
              }}
              muiSelectProps={{ fullWidth: true, variant: "outlined" }}
              name="type"
              {...settings.selectButtonsProps}
              options={[
                {
                  value: "unemployed",
                  label: text.situation_typeBenefits_unemployed,
                },
                {
                  value: "mutualiteit",
                  label: text.situation_typeBenefits_mutualiteit,
                },
                {
                  value: "integration",
                  label: text.situation_typeBenefits_integration,
                },
                {
                  value: "earlyRetirement",
                  label: text.situation_typeBenefits_earlyRetirement,
                },
                {
                  value: "retirementPension",
                  label: text.situation_typeBenefits_retirementPension,
                },
                {
                  value: "governmentPension",
                  label: text.situation_typeBenefits_governmentPension,
                },
                {
                  value: "specialPensions",
                  label: text.situation_typeBenefits_specialPensions,
                },

                {
                  value: "livingWage",
                  label: text.situation_typeBenefits_livingWage,
                },
              ]}
            />
          </Question>
          <Question
            spacing={2.25}
            showIf={
              situation === "employee" &&
              fullTime === "false" &&
              form.watch("type") == "teacher"
            }
          >
            <div>
              <Label label={text.eduction_deferred_renumeration} />
              <ReactMarkdown
                children={text.eduction_deferred_renumeration_tooltip}
                options={{
                  overrides: {
                    p: {
                      component: Typography,
                      props: { paragraph: false, variant: "caption" },
                    },
                    a: { component: Link },
                  },
                  forceBlock: true,
                }}
              />
            </div>

            <RadioButton
              name={`educationDeferredRenumeration`}
              minButtonWidth="240px"
              {...settings.selectButtonsProps}
              options={[
                { value: "true", label: text.general_yes },
                { value: "false", label: text.general_no },
              ]}
              rules={{
                required: text.general_requiredQuestion,
              }}
            />
          </Question>
          <Question showIf={form.watch("situation") === "student"}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <ErrorOutlineOutlinedIcon
                htmlColor={theme.palette.primary.light}
                fontSize="small"
                style={{ marginRight: theme.spacing(1) }}
              />
              <Markdown>{text.situation_studentWarning}</Markdown>
            </div>
          </Question>
        </Section>
      </StepBody>
      <NavigationButtons onBack={onBack} onNext={form.handleSubmit(onSubmit)} />
    </ReactEasyForm>
  );
};
export default Situatie;
